import * as React from "react";
import type { SVGProps } from "react";
const SvgInternet = (props: SVGProps<SVGSVGElement>) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={25} fill="none" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M9.772 4.814A8.02 8.02 0 0 0 5.07 8.5h3.067c.366-1.282.91-2.523 1.635-3.686m.459 3.686A12.5 12.5 0 0 1 12 5.09a12.5 12.5 0 0 1 1.77 3.41zm-.493 6h4.524a12.6 12.6 0 0 0 0-4H9.738a12.6 12.6 0 0 0 0 4m4.031 2h-3.538c.403 1.2.993 2.352 1.769 3.41a12.5 12.5 0 0 0 1.77-3.41m-5.632 0a14.5 14.5 0 0 0 1.636 3.686 8 8 0 0 1-1.564-.64 1 1 0 0 0-.95 1.761A9.96 9.96 0 0 0 12 22.5c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10a9.96 9.96 0 0 0 1.904 5.871 1 1 0 1 0 1.618-1.175 8 8 0 0 1-.452-.696zm7.726 0h3.067a8.02 8.02 0 0 1-4.703 3.686 14.5 14.5 0 0 0 1.636-3.686m3.885-2h-3.464a14.6 14.6 0 0 0 0-4h3.464c.165.64.252 1.31.252 2s-.087 1.36-.252 2m-5.52-9.686A14.5 14.5 0 0 1 15.862 8.5h3.067a8.02 8.02 0 0 0-4.703-3.686M7.716 10.5H4.252a8 8 0 0 0-.252 2c0 .69.087 1.361.252 2h3.464a14.6 14.6 0 0 1 0-4"
            clipRule="evenodd"
        />
    </svg>
);
export default SvgInternet;
